import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=13d82005"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports